import { createContext } from 'react';
import { RootStoreType } from './types';

const StoreContext = createContext<RootStoreType | null>(null);

export default StoreContext;
